export const siteSettings = {
  name: "Trade Market Options",
  link: "https://trademarketoptions.com",
  email: "support@trademarketoptions.com",
  appLink: "https://app.trademarketoptions.com",
};
